// extracted by mini-css-extract-plugin
module.exports = {"customNode":"styles_customNode__21gDq","position":"styles_position__2vme6","typed":"styles_typed__3Dn2M"};